<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-clipboard-list"
      texto-titulo="Listado de Familias"
      :to-create-action="{name:'NuevaFamilia'}"
      to-create-text="Nueva Familia"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList url="/familias" :fields="fields" :rowClick="mostrarOpciones"></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import DataList from '@/components/layouts/DataList'
import Swal from "sweetalert2";
import axios from "axios";
export default {
  name: "ListarFamilias",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      familias: [],
      fields: [
        {
          name: "descripcion",
          label: "",
          type: "title",
          class: ""
        }
      ],
      loading: false
    };
  },
  mounted() {
  },
  methods: {
    mostrarOpciones(familia) {
      Swal.fire({
        title: familia.descripcion,
        showCancelButton: true,
        confirmButtonText: "Editar",
        cancelButtonText: "Eliminar",
        confirmButtonColor: "#f7b924",
        cancelButtonColor: "#d33",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.$router.push({name:'EditarFamilia', params:{id:familia.id}})
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.eliminarFamilia(familia)
        }
      });
    },
    eliminarFamilia(familia) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${familia.descripcion} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/familias/" + familia.id)
            .then(res => {
              Swal.fire(
                "Eliminado",
                `${res.data.familia.descripcion} se ha eliminado con éxito.`,
                "success"
              );
              this.$refs.datatable.update();
            })
            .catch(err => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    }
  }
};
</script>